import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/';

const debugEnv = process.env.NODE_ENV !== 'production';

/**
 * Configure the store with middleware:
 * thunk - thunk actions (actions that return a function)
 * createLogger - log action dispatch in browser console [LOCAL env only]
 * devToolsExtension - log action dispatch in dev tools extension [LOCAL env only]
 */

export default function configureStore(initialState) {
	return debugEnv ?
		compose(
			applyMiddleware(thunk),
			window.devToolsExtension ? window.devToolsExtension() : f => f
		)(createStore)(rootReducer, initialState)
		:
		compose(applyMiddleware(thunk))(createStore)(rootReducer, initialState);
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/store/configureStore.js